<template>
  <v-container class="px-5 py-0" fill-height>
      <v-layout justify-center align-center>
        <v-progress-circular v-if="!packages.paymentFrame" indeterminate color=accent />
        <iframe v-else
          id="payment_iframe"
          ref="payment_iframe"
          class="full-height pt-5"
          style="margin: auto;"
          frameBorder="0"
          seamless='seamless'
          :src="packages.paymentFrame"
        />
      </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import routeNames from '@/router/routes'
export default {
  beforeCreate () {
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
    var eventer = window[eventMethod]
    var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
    const context = this
    eventer(messageEvent, function (e) {
      context.handleMessage(e)
    }, false)
  },
  methods: {
    handleMessage (event) {
      if (event.data && event.data.message === 'redirect') {
        this.$router.push({ name: routeNames.paymentResult.name, query: event.data.payload })
      }
    }
  },
  computed: {
    ...mapState(['packages'])
  },
  beforeDestroy () {
    this.$store.commit('packages/resetPaymentUrl')
    var eventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent'
    var eventRemove = window[eventMethod]
    var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
    const context = this
    eventRemove(messageEvent, function (e) {
      context.handleMessage(e)
    }, false)
  }
}
</script>
